import { SPACED_ROW_HEIGHT, SPACING } from './constants';
export const customStyles = (props, rtl) => {
    return {
        valueContainer: (provided) => ({
            ...provided,
            padding: '3px 8px',
        }),
        input: (provided) => ({
            ...provided,
            color: '#000000',
        }),
        noOptionsMessage: (provided) => ({
            ...provided,
            color: 'rgb(100, 100, 100)',
            textAlign: 'left',
            padding: '6px 22px',
        }),
        multiValue: (provided) => ({
            ...provided,
            margin: '4px',
            paddingLeft: 0,
            fontSize: '12px',
            lineHeight: '16px',
            borderRadius: 0,
            backgroundColor: 'rgba(0,0,0,0.1)',
            ':hover': {
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
            ':selected': {
                color: '#ffffff',
                backgroundColor: '#000000',
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#969696',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            fontSize: '12px',
            lineHeight: '16px',
            paddingTop: '4px',
            paddingRight: rtl ? '12px' : '0',
            paddingBottom: '4px',
            paddingLeft: rtl ? '0' : '12px',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            backgroundColor: 'transparent',
            ':hover': {
                backgroundColor: 'transparent',
            },
        }),
        option: (provided) => {
            return {
                ...provided,
                height: 60,
                ':active': {
                    backgroundColor: 'rgba(0,0,0,0.06)',
                },
                ':hover': {
                    backgroundColor: 'rgba(0,0,0,0.06)',
                },
            };
        },
        menu: (provided) => {
            return {
                ...provided,
                marginTop: 0,
                paddingTop: 8,
                paddingBottom: 8,
                borderRadius: 0,
            };
        },
        control: (provided) => ({
            // Main box
            ...provided,
            minHeight: 40,
            overflowY: 'hidden',
            maxHeight: `${(props.rows || 1) * SPACED_ROW_HEIGHT + SPACING}px`,
            borderRadius: 0,
            borderColor: 'rgba(0,0,0,0.6)',
            ':active': {
                borderColor: 'rgba(0,0,0,1)',
            },
            ':hover': {
                borderColor: 'rgba(0,0,0,1)',
            },
            boxShadow: 'none',
        }),
    };
};
//# sourceMappingURL=CustomStyles.js.map